import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import ImageUploading from "react-images-uploading";
import { useScreenshot, createFileName } from 'use-react-screenshot';
import Moveable from "react-moveable";
import Selecto from "react-selecto";
import styled from 'styled-components';
import notes from './notes';
import upload from './assets/img/upload.svg';
import downloadImg from './assets/img/download.svg';
import './App.css';

const App = () => {

  const itemRef = useRef(null);
  const exportRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const [itemWidth, setItemWidth] = useState(null);
  const [itemHeight, setItemHeight] = useState(null);


  // select image
  const [images, setImages] = useState([]);
  const maxNumber = 1;

  const onChange = (imageList, addUpdateIndex) => {
      setImages(imageList);
  };


  // notes
  const [postIt, setPostIt] = useState(notes[0]);
  const [noteSelected, setNoteSelected] = useState(0);
  const onNoteChange = (note, i) => {
      setPostIt(note);
      setNoteSelected(i);
  };


  const NotesList = () => {
    return (
      <>
        {notes.map((note, i) => {
          return (
            <div key={i.toString()} className={`note ms-1 mb-1 mb-md-0 ${loaded && noteSelected == i ? 'active' : !loaded ? 'inactive' : ''}`} onClick={() => onNoteChange(note, i)}>
                <svg height="50" width="51" fill="none" viewBox="0 0 51 50" xmlns="http://www.w3.org/2000/svg">
                    <rect height="47.2229" width="48.6539" stroke="#D24141" strokeWidth="2.1465" x="1.07325" y="1.70386"/>
                    <g clipPath="url(#clip0_1770_87)"><path d="M16.274 35.6923L14.3101 15.4735L34.5289 13.5095L36.4929 33.7284L16.274 35.6923ZM16.6249 17.3786L18.1791 33.3775L34.178 31.8233L32.6238 15.8244L16.6249 17.3786Z" fill="#1A1A1A"/><path d="M30.5208 19.2468L19.5962 20.3083L19.8012 22.4178L30.7257 21.3563L30.5208 19.2468Z" fill="#1A1A1A"/><path d="M28.9755 23.2006L19.8721 24.0852L20.077 26.1946L29.1805 25.3101L28.9755 23.2006Z" fill="#1A1A1A"/></g>
                    <defs><clipPath id="clip0_1770_87"><rect height="22.1805" width="22.1805" fill="white" transform="translate(14.3101 13.5095)"/></clipPath></defs>
                </svg>
            </div>
          )
        })}
      </>
    );
  }


  // moveable
  const moveableRef = useRef(null);
  const selectoRef = useRef(null);
  const [target, setTarget] = useState();
  const [frame, setFrame] = useState({
      translate: [0,0],
      rotate: 0
  });


  // download
  const [downloading, setDownloading] = useState(false);
  const [image, takeScreenshot] = useScreenshot({
      type: "image/jpeg",
      quality: 1.0
  });
  // const getImage = () => takeScreenshot(exportRef.current);

  const download = (image, { name = "goal-14", extension = "jpg" } = {}) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const downloadScreenshot = () => {
      setTarget([]);
      setDownloading(true);
  }

  useLayoutEffect(() => {
    if (Array.isArray(target) && downloading) {
        if (target.length === 0) {
            takeScreenshot(exportRef.current).then(download);
        }
    }
 }, [downloading]);

  useEffect(() => {
    if (itemRef.current) {
      const width = window.getComputedStyle(itemRef.current).width;
      const height = window.getComputedStyle(itemRef.current).height;
      const w = parseInt(width, 10);
      const h = parseInt(height, 10);
      setItemWidth(w);
      setItemHeight(h);
    }
  }, [loaded]);

  return (
    
    <div className="position-relative h-100">
      <ImageUploading
          multiple
          value={images}
          onChange={onChange}
          maxNumber={maxNumber}
          dataURLKey="data_url"
      >
          {({
              imageList,
              onImageUpload,
              onImageRemoveAll,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps,
              errors
          }) => (
              <div className="upload__image-wrapper d-flex flex-column h-100">
                  <ButtonsWrapper className="d-flex justify-content-between">
                      <ToolButton
                          className="tool-button-1"
                          style={isDragging ? `color: red` : undefined}
                          onClick={onImageUpload}
                          {...dragProps}
                      >
                          Upload your image
                          <img src={upload} alt="upload-icon" />
                      </ToolButton>
                      <ToolButton className={`${!loaded ? `inactive` : ``}`} onClick={downloadScreenshot}>
                          Download image
                          <img src={downloadImg} alt="download-icon" />
                      </ToolButton>
                  </ButtonsWrapper>

                    <ButtonsWrapper className="sticky-notes-wrapper d-flex align-items-end justify-content-between mt-4">
                        <span>Sticky note options:</span>
                        <div className="d-flex flex-wrap justify-content-end ms-md-3">
                            <NotesList />
                        </div>
                    </ButtonsWrapper>
                  
                  {imageList && imageList.map((image, i) => (
                      <ImageItem key={i.toString()}>
                          <div className="image-item-wrapper position-relative" ref={exportRef}>
                              <img className="background-image-tool" src={image["data_url"]} ref={itemRef} alt="Tool ploaded" onLoad={() => setLoaded(true)} />
                              
                              {/* {loaded && <PostIt width={itemWidth} height={itemHeight} postIt={postIt} />} */}
                              {loaded && <>
                                <img src={postIt} className="target" alt="Overlay title" onLoad={() => setTarget(document.querySelector(".target"))} />

                                <Selecto
                                    ref={selectoRef}
                                    selectableTargets={[".target"]}
                                    hitRate={0}
                                    selectByClick={true}
                                    selectFromInside={false}
                                    ratio={0}
                                    onDragStart={e => {
                                        const moveable = moveableRef.current;
                                        const targetEl = e.inputEvent.target;
                                        if (
                                            moveable.isMoveableElement(targetEl)
                                        ) {
                                            e.stop();
                                        }
                                    }}
                                    onSelectEnd={e => {
                                        const moveable = moveableRef.current;
                                        // actions.theme.imageTargetAction(e.selected);
                                        setTarget(e.selected);
                                    
                                        if (e.isDragStart) {
                                            e.inputEvent.preventDefault();
                                    
                                            setTimeout(() => {
                                                moveable.dragStart(e.inputEvent);
                                            });
                                        }
                                    }}
                                />

                                <Moveable
                                    ref={moveableRef}
                                    target={target}
                                    draggable={true}
                                    throttleDrag={0}
                                    startDragRotate={0}
                                    throttleDragRotate={0}

                                    snappable={true}
                                    snapThreshold={5}
                                    snapCenter={false}
                                    bounds={{ left: 0, top: 0, bottom: itemHeight, right: itemWidth }}

                                    resizable={true}
                                    keepRatio={true}
                                    throttleResize={0}
                                    renderDirections={["nw","ne","sw","se"]}
                                    edge={false}

                                    rotatable={true}
                                    throttleRotate={0}
                                    rotationPosition={"top"}

                                    pinchable={true}
                                    pinchThreshold={20}

                                    zoom={1}
                                    origin={true}
                                    padding={{"left": 0, "top": 0, "right": 0, "bottom": 0}}

                                    onDragStart={e => {
                                        e.set(frame.translate);
                                    }}
                                    onDrag={e => {
                                        frame.translate = e.beforeTranslate;
                                        e.target.style.transform = `translate(${e.beforeTranslate[0]}px, ${e.beforeTranslate[1]}px) rotate(${frame.rotate}deg)`;
                                    }}
                                    onRotateStart={e => {
                                        e.set(frame.rotate);
                                    }}
                                    onRotate={({beforeRotate, target}) => {
                                        frame.rotate = beforeRotate;
                                        target.style.transform = `translate(${frame.translate[0]}px, ${frame.translate[1]}px) rotate(${beforeRotate}deg)`;
                                    }}
                                    onResizeStart={e => {
                                        e.setOrigin(["%", "%"]);
                                        e.dragStart && e.dragStart.set(frame.translate);
                                    }}
                                    onResize={e => {
                                        const beforeTranslate = e.drag.beforeTranslate;
                                        frame.translate = beforeTranslate;
                                        e.target.style.width = `${e.width}px`;
                                        e.target.style.height = `${e.height}px`;
                                        e.target.style.transform = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px) rotate(${frame.rotate}deg)`;
                                    }}
                                />
                              </>}
                          </div>
                          <div className="image-item__btn-wrapper">
                              <ToolButton onClick={() => {setLoaded(false); onImageUpdate(i)}}>Upload new image</ToolButton>
                          </div>
                      </ImageItem>
                  ))}
                  {!imageList.length && <ImagePlaceholder>No Image</ImagePlaceholder>}
                  {errors && (
                      <div style={{ color: "red" }}>
                          {errors.maxNumber && (
                              <span>Number of selected images exceed the limit</span>
                          )}
                          {errors.acceptType && (
                              <span>File type not allowed</span>
                          )}
                          {errors.maxFileSize && (
                              <span>Selected file size exceed</span>
                          )}
                          {errors.resolution && (
                              <span>Selected file doesn't match the desired resolution</span>
                          )}
                      </div>
                  )}
              </div>
          )}
      </ImageUploading>
    </div>
  );
}

export default App;

const ButtonsWrapper = styled.div`
    width: 100%;
    @media screen and (max-width: 460px) {
        &:not(.sticky-notes-wrapper) {
            flex-direction: column;
        }
        &.sticky-notes-wrapper {
            align-items: flex-start;
        }
    }
    span {
        text-transform: uppercase;
        font-family: var(--font-bold);
        word-spacing: 0.04em;
        font-size: 30px;
        color: var(--black-0);
        @media screen and (max-width: 460px) {
            max-width: 30%;
        }
    }
    .note {
        &.inactive {
            opacity: .5;
            filter: grayscale(1);
            pointer-events: none;
        }
        &:not(.inactive) {
            cursor: pointer;
            &:hover {
                svg {
                    > rect {
                        fill: #D24141;
                    }
                }
            }
        }
        &.active {
            svg {
                > rect {
                    fill: #D24141;
                }
            }
        }
    }
`;

const ToolButton = styled.button`
    padding: 20px 32px;
    border: 3px solid #D24141;
    background-color: transparent;
    text-transform: uppercase;
    font-family: var(--font-bold);
    word-spacing: 0.04em;
    font-size: 30px;
    color: var(--black-0);
    img {
        margin-left: 10px;
    }
    &:not(.inactive)&:hover {
        background-color: #D24141;
    }
    &.inactive {
        opacity: .5;
        filter: grayscale(1);
        pointer-events: none;
    }
    &.tool-button-1 {
        @media screen and (max-width: 460px) {
            margin-bottom: 10px;
        }
    }
`;

const ImagePlaceholder = styled.div`
    border: 1px solid #B1B1B1;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    font-family: var(--font-bold);
    word-spacing: 0.04em;
    font-size: 60px;
    color: #cccccc;
    min-height: 500px;
    width: 100%;
    margin-top: 30px;
    flex-grow: 1;
`;

const ImageItem = styled.div`
    margin-top: 30px;
    .target {
        position: absolute;
        top: 30px;
        left: 30px;
        max-width: 70%;
    }
    .image-item__btn-wrapper {
        button {
            margin-top: 30px;
            font-size: 20px;
            padding: 10px 22px;
        }
    }
`;